import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { getMethod } from "../../utils/apiServices";

export const getDevelopmentType = createAsyncThunk("developmentType/fetchDevelopmentType", async () => {
  // setAuthorizationToken(true);
  const response = await getMethod(`/api/development-type`);
  return response;
});

const initialState = {
  loading: false,
  success: false,
  error: false,
  developmentType: null,
};

const developmentTypeSlice = createSlice({
  name: "developmentType",
  initialState,
  // reducers: {
  //   isLoading: (state) => {
  //     state.loading = true;
  //     state.success = false;
  //     state.error = false;
  //   },
  //   isSuccess: (state, action) => {
  //     state.loading = false;
  //     state.success = true;
  //     state.error = false;
  //     state.developmentType = action.payload;
  //   },
  //   isError: (state) => {
  //     state.loading = false;
  //     state.success = false;
  //     state.error = true;
  //   },
  // },

  extraReducers: (builder) => {
    builder.addCase(getDevelopmentType.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getDevelopmentType.fulfilled, (state, action) => {
      state.loading = false;
      state.developmentType = action.payload.data;
    });
    builder.addCase(getDevelopmentType.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload.message;
    });
  },
});

// export const { isLoading, isSuccess, isError } = developmentTypeSlice.actions;

export default developmentTypeSlice.reducer;

// export const getDevelopmentType = () => async (dispatch) => {
//   try {
//     dispatch(isLoading);
//     const response = await getMethod(`/api/development-type`);
//     dispatch(isSuccess(response?.data));
//   } catch (error) {
//     dispatch(isError);
//   }
// };
